module.exports = __webpack_public_path__ + "static/img/case_banner_09_h5.d53dae3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_banner_09_h5.png
// module id = w00v
// module chunks = 34